import { useState } from "react";
import { updateBarLabel, type UpdateBarState } from "../apkUpdate";

export function UpdateBar({
  state,
  onDownload,
  onInstall,
}: {
  state: UpdateBarState;
  onDownload: () => void;
  onInstall: () => void;
}) {
  const [notesOpen, setNotesOpen] = useState(false);
  if (state.phase === "hidden") return null;
  const label = updateBarLabel(state);
  const primary = state.phase === "ready" ? onInstall : state.phase === "downloading" ? undefined : onDownload;
  return (
    <div className="update-host" data-testid="apk-update-bar" data-phase={state.phase}>
      <div className="update-bar">
        <button
          type="button"
          className="update-bar-main"
          data-testid="apk-update-action"
          disabled={state.phase === "downloading"}
          onClick={primary}
        >
          {label}
        </button>
        {state.notes ? (
          <button
            type="button"
            className="update-notes-btn"
            data-testid="apk-update-notes"
            aria-expanded={notesOpen}
            onClick={() => setNotesOpen((open) => !open)}
          >
            What's new
          </button>
        ) : null}
        {state.phase === "downloading" ? (
          <div className="update-progress-track" aria-hidden>
            <div className="update-progress-fill" style={{ width: `${Math.round(state.progress * 100)}%` }} />
          </div>
        ) : null}
        {state.error && state.phase === "ready" ? <p className="update-notes">{state.error}</p> : null}
        {notesOpen && state.notes ? (
          <p className="update-notes" data-testid="apk-update-notes-body">
            {state.notes}
          </p>
        ) : null}
      </div>
    </div>
  );
}
